import { SaveEstimateTemplateCommand } from "./../api/estimate-templates-api";
import { Module } from "vuex";
import RootState from "./root-state";
import {
  EstimateTemplate,
  getEstimateTemplates,
  saveEstimateTemplate
} from "@/api/estimate-templates-api";
import { getPhotoEntries } from "@/api/photo-api";
import { Breadcrumb } from "@/models/file";

export const estimateTemplate = {
  namespaced: true,
  state: {
    estimateTemplates: [],
    breadcumbs: [],
    documentId: 0
  },
  mutations: {
    estimateTemplates(state, estimateTemplates: EstimateTemplate[]) {
      state.estimateTemplates = estimateTemplates;
    },
    breadcumbs(state, breadcumbs: Breadcrumb[]) {
      state.breadcumbs = breadcumbs;
    },
    documentId(state, documentId: string | number) {
      state.documentId = documentId;
    }
  },
  actions: {
    async load({ commit }) {
      const templates = await getEstimateTemplates();
      commit("estimateTemplates", templates);
    },
    async save({ commit, dispatch }, command: SaveEstimateTemplateCommand) {
      await saveEstimateTemplate(command);
      await dispatch("load");
      const { path } = await getPhotoEntries(null, command.documentId);
      commit("breadcumbs", path);
      commit("documentId", command.documentId);
    }
  }
} as Module<EstimateTemplateState, RootState>;

interface EstimateTemplateState {
  estimateTemplates: EstimateTemplate[];
  breadcumbs: Breadcrumb[];
  documentId: string | number;
}
